/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolflyer3Inputs */

const en_medialibrarytoolflyer3 = /** @type {(inputs: Medialibrarytoolflyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer`)
};

const de_medialibrarytoolflyer3 = /** @type {(inputs: Medialibrarytoolflyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer`)
};

/**
* | output |
* | --- |
* | "Flyer" |
*
* @param {Medialibrarytoolflyer3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolflyer3 = /** @type {((inputs?: Medialibrarytoolflyer3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolflyer3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolflyer3(inputs)
	return de_medialibrarytoolflyer3(inputs)
});
export { medialibrarytoolflyer3 as "mediaLibraryToolFlyer" }